import gql from 'graphql-tag';
import SUPPORT_TOPIC_FRAMENT from '../fragments/support-topic';
import SUPPORT_CATEGORY_FRAMENT from '../fragments/support-category';
import TAG_FRAGMENT from '../fragments/tag';

const GET_SUPPORT_TOPIC = gql`
  query getSupportTopic($where: SupportTopicWhereInput) {
    supportTopic(where: $where) {
      ...BaseSupportTopic
      content
      tags {
        ...BaseTag
      }
      supportCategories {
        ...BaseSupportCategory
      }
    }
  }
  ${SUPPORT_TOPIC_FRAMENT}
  ${SUPPORT_CATEGORY_FRAMENT}
  ${TAG_FRAGMENT}
`;

export default GET_SUPPORT_TOPIC;
